export const ICON_FONT_SIZE_MAP: { [name in IconFontSize]: string } = {
  default: '24px',
  small: '20px',
  xs: '16px',
  inherit: 'inherit',
}

export type IconFontSize = 'default' | 'small' | 'xs' | 'inherit'
